module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/scal360/view-scal360-download-release-history/view-scal360-download-release-history.component.css
// module id = 995
// module chunks = 1